import React from 'react';
import { Card } from 'react-bootstrap';

const SceneCard = ({ scenes }) => {
    return (
        //let oocplayers = [...new Set(whosOnline.filter(who => who.isooc === true).map(who => who.userName))];
        <Card className={"m-2 score-card-eom-overview"} >
            <Card.Header className={"going-on-header"}>
                <Card.Title>Plots & Scenes</Card.Title>
            </Card.Header>
            <Card.Body>
                {scenes.map((scene, index) =>
                    <div key={index} className="divtext mb-2">
                        <a key={scene.scene_id} className="dryLink pb-2" href={`/player/scene/${scene.scene_id}`}>
                            <h5 className={"pt-0"}>{scene.scene_title}</h5>
                            <small>{scene.scene_status} - Updated {scene.scene_updated}</small>
                        </a>
                        <br />
                    </div>
                )}


            </Card.Body>
        </Card>

    );
}

export default SceneCard;